import React from 'react';
import { InfoCardData } from './types';
import { LeafLogo } from '@/components/logos/LeafLogo';
import { GreenTickLogo } from '@/components/logos/GreenTickLogo';
import { YellowMinusLogo } from '@/components/logos/YellowMinusLogo';
import { RedXLogo } from '@/components/logos/RedXLogo';

const getPaybackPeriodLogo = (value: number) => {
  if (value <= 8) {
    return (
      <span
        className="tooltip tooltip-primary custom-green-tooltip"
        style={{ color: '#12B76A !important' }}
        data-tip={'Diese Technologie könnte sich für Sie eignen.'}
      >
        <GreenTickLogo />
      </span>
    );
  } else if (value > 8 && value <= 14) {
    return (
      <span className="tooltip tooltip-primary custom-yellow-tooltip" data-tip={'Diese Technologie könnte sich unter Umständen für Sie eignen.'}>
        <YellowMinusLogo />
      </span>
    );
  } else {
    return (
      <span className="tooltip tooltip-primary custom-red-tooltip" data-tip={'Diese Technologie eignet sich voraussichtlich nicht für Sie.'}>
        <RedXLogo />
      </span>
    );
  }
};

const InfoCard: React.FC<InfoCardData> = ({ cards, highlight, paybackPeriod, investmentCost, presentValue }) => (
  <div className="">
    <div className="info-fields">
      {cards.map((field, idx) => (
        <div className="info-field" key={idx}>
          <p className="label text-[12px] text-[#7A818B] font-normal p-0">{field.label}</p>
          <p className="text-[18px] font-semibold">
            {field.value} {field?.unit ? <span className="sup">{field.unit}</span> : null}
          </p>
        </div>
      ))}
    </div>
    <div className="grid grid-cols-2 gap-[10px]">
      {paybackPeriod && (
        <div className="mt-[12px] bg-[#fafafa] rounded-[10px] p-[10px] flex justify-between items-center">
          <div>
            <p className="label text-[12px] text-[#7A818B] font-normal p-0">{paybackPeriod.label}</p>
            <p className="text-[18px] font-semibold">
              {paybackPeriod.value} <span className="sup">{paybackPeriod.unit}</span>
            </p>
          </div>
          {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            //@ts-ignore
            getPaybackPeriodLogo(Number(paybackPeriod.value?.replaceAll(',', '.')))
          }
        </div>
      )}
      {highlight && (
        <div className="flex justify-between items-center info-highlight">
          <div className="">
            <span className="label text-[#696969] text-[12px] p-0">{highlight.label}:</span>
            <span className="text-[18px] font-semibold">
              {highlight.value} <span className="sup">{highlight.unit}</span>
            </span>
          </div>
          <LeafLogo />
        </div>
      )}
    </div>
    {investmentCost || presentValue ? (
      <div className="bg-[#fafafa] rounded-[10px] p-[10px] grid grid-cols-2 mt-[12px]">
        {investmentCost && (
          <div>
            <p className="label text-[12px] text-[#7A818B] font-normal p-0">Investitionskosten</p>{' '}
            <p className="text-[18px] font-semibold">{investmentCost}</p>{' '}
          </div>
        )}
        {presentValue && (
          <div>
            <p className="label text-[12px] text-[#7A818B] font-normal p-0">Barwert (bei 6% WACC)</p>
            <p className="text-[18px] font-semibold">{presentValue}</p>{' '}
          </div>
        )}
      </div>
    ) : null}
  </div>
);

export default InfoCard;
